<script>
  import PageHero from '$lib/page/Hero.svelte';
  import EntryContent from '$lib/EntryContent.svelte';
  import FundingBlue from '$lib/singleService/Funding.svelte';
  import FundingWhite from '$lib/services/Funding.svelte';
  import Back from '$lib/singlePortfolio/Back.svelte';
  import Seo from '$lib/Seo.svelte';
  import Faq from '$lib/faq/Index.svelte';
  import Discover from '$lib/singleService/discover/Index.svelte';
  import CallToAction from '$lib/company/CallToAction.svelte';
  import CallToActionImage from '$lib/company/CallToActionImage.svelte';

  export let page_hero;
  export let blocks;
  export let funding;
  export let cta;
  export let discover;
  export let back;
  export let seo;
  export let faq;
  export let cta_image = cta;
  let image = {
    src: 'https://www.caballero.lv/uploads/2023/04/pic-12-1920x1261.jpg',
  };
</script>

<PageHero hero={page_hero} />
{#if blocks}
  <EntryContent {blocks} />
{/if}
{#if funding}
  {#if funding.type == 'blue'}
    <FundingBlue {funding} contact={funding.contact} />
  {/if}
  {#if funding.type == 'white'}
    <FundingWhite {funding} contact={funding.contact} />
  {/if}
{/if}
{#if cta}
  <CallToAction title={cta.title} desc={cta.text} link={cta.link} />
{/if}
{#if cta_image}
  <CallToActionImage
    title={cta_image.title}
    desc={cta_image.text}
    link={cta_image.link}
    {image}
  />
{/if}
{#if discover}
  <Discover {discover} />
{/if}
<Back {back} />
{#if seo}
  <Seo {seo} />
{/if}
{#if faq}
  <Faq {faq} />
{/if}
